<template>
  <div id="config-slide-show-editor">
    <CRow>
      <CCol xs="12" md="12" lg="12">
        <CCard style="border-radius: unset!important;">
          <CCardHeader
            style="border-radius: unset!important;position: unset!important;background: white!important;border-bottom: unset!important;"
            color="light"
            class="d-inline-flex justify-content-between align-items-center">
            <strong style="font-size: 18px;padding: 8px 0px;width: 100%;border-bottom: 1px solid #d8dbe0;">
              {{ getTitleHeader }}
            </strong>
          </CCardHeader>

          <CCardBody style="padding: unset!important; min-height: 70vh;">

            <template v-if="action === actionEditor.LAYOUT_SETTING">
              <div class="content-fade-in">
                <CCol xs="12" md="12" lg="12">
                  <BaseSelect :options="typeSelect.options" :data="typeSelect.data"
                              ref="typeSelect"></BaseSelect>
                </CCol>
                <!--                <CCol xs="12" md="12" lg="12">-->
                <!--                  <BaseSelect :options="ratioSelect.options" :data="ratioSelect.data"-->
                <!--                              ref="ratioSelect"></BaseSelect>-->
                <!--                </CCol>-->
                <hr class="mt-4"/>

                <div class="group-layer-setting">
                  <div class="card-header d-inline-flex justify-content-between align-items-center bg-light title">
                    Bố cục giao diện
                  </div>
                  <CCol xs="12" md="12" lg="12">
                    <template v-if="items != null && items.length > 0">
                      <draggable :list="items" class="layers-wrapper" ghost-class="ghost"
                                 group="people"
                                 :move="checkMoveLayer"
                                 @start="drag=true"
                                 @end="drag=false">
                        <ul v-for="(element) in items">
                          <li class="layout_layer">
                            <span class="description" style="width: 85%;" @click.self="activeLayer(element.id)">
                              {{ getTitleLayer(element) }}
                             </span>
                            <div class="text-right" @click="removeLayer(element.id)">
                              <i class="fa fa-trash" v-c-tooltip.hover="'Xóa'"></i>
                            </div>
                          </li>
                        </ul>
                      </draggable>
                    </template>
                    <template v-else>
                      <span class="no-layers-content-message" :class="isValidSubmit ? 'valid-error' : ''">Chưa có nội dung nào!</span>
                    </template>
                  </CCol>
                </div>
              </div>
            </template>

            <template v-else-if="action === actionEditor.ADD_LAYER">
              <div class="fadeInUp fade animated">
                <CRow style="margin: unset;padding: 15px;">
                  <template v-for="itemChoose of itemsLayerChoose">
                    <CCol :key="itemChoose.id" xs="12" md="12" lg="12" xl="6" class="layout-insert-item-column mb-3">
                      <div class="layout-insert-item-type" :class="itemChoose.disabled ? 'disabled' : ''"
                           @click="chooseLayer(itemChoose)">
                        <span style="color: #000000b3;width: 70%;font-weight: 500;">{{ itemChoose.title }}</span>
                        <!--                        <i class="fa" :class="itemChoose.icon"></i>-->
                      </div>
                      <!--                      <span class="layout-insert-item-label"> {{ itemChoose.title }} </span>-->
                    </CCol>
                  </template>
                </CRow>
              </div>
            </template>

            <template v-else-if="action === actionEditor.EDITOR_LAYER">
              <!--              <ConfigSlideShowFormEditor :type="items[itemSelected].extractData.typeLayer" :item="items[itemSelected]"/>-->
              <SlideShowFormEditor :type="items[itemSelected].extractData.typeLayer" :item="items[itemSelected]"/>
            </template>

          </CCardBody>

          <CCardFooter style="text-align: center" class="mt-2">
            <CButton
              color="primary"
              class="btn-action-primary mr-2" @click="submitSaveSlideShow()">
              <i class="fa fa-save"></i> Lưu lại
            </CButton>
            <CButton
              color="secondary"
              class="btn-action-primary" @click="$router.go(-1)">
              <i class="fa fa-reply"></i> Hủy bỏ
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>
<script>

import BaseSelect from "@/views/base/BaseSelect2";
import draggable from 'vuedraggable'
import {ActionEditor, TypeChooseLayer} from "@/constant";
import SlideShowFormEditor from "@/views/slide_show/SlideShowFormEditor";

export default {
  name: 'ConfigSlideShowEditor',
  components: {SlideShowFormEditor, BaseSelect, draggable},
  props: {
    items: Array,
    action: {
      type: Number
    },
    type: Number,
    itemSelected: Number,
    size: Object,
    ratio: {
      type: String,
    }
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data: function () {
    let that = this;
    return {
      loading: {value: false},
      actionEditor: ActionEditor,
      typeLayer: TypeChooseLayer,
      typeSelect: {
        options: {
          filter: false,
          label: "Loại",
          'keyField': 'key',
          'valueField': 'value',
        },
        data: {
          name: "type",
          model: that.type,
          items: [
            {key: "0", value: "Toàn màn hình"},
            {key: "1", value: "Phân 3 vùng"},
          ],
        }
      },
      ratioSelect: {
        options: {
          filter: false,
          label: "Ratio <i></i>",
          'keyField': 'key',
          'valueField': 'value',
        },
        data: {
          name: "ratio",
          model: '16:9',
          items: [
            {key: "16:9", value: "16:9 (1080p)"},
            {key: "16:10", value: "16:10"},
            {key: "4:3", value: "4:3"},
            {key: "5:4", value: "5:4"},
            {key: "3:2", value: "3:2"},
            {key: "17:9", value: "17:9"},
            {key: "16:4.5", value: "16:4.5"},
            {key: "16:3", value: "16:3"},
          ],
        }
      },
      itemsLayerChoose: [
        {id: 1, typeLayer: TypeChooseLayer.AREA_TEXT, title: 'Vùng văn bản', icon: 'fa-file-text', disabled: false},
        {id: 2, typeLayer: TypeChooseLayer.AREA_LEFT, title: 'Vùng trái', icon: 'fa-left', disabled: false},
        {id: 3, typeLayer: TypeChooseLayer.AREA_RIGHT, title: 'Vùng phải', icon: 'fa-right', disabled: false},
      ],
      isValidSubmit: false,
    }
  },
  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    getTitleHeader() {
      if (this.action === this.actionEditor.LAYOUT_SETTING) {
        return 'Cài đặt giao diện';
      } else if (this.action === this.actionEditor.ADD_LAYER) {
        return 'Thêm giao diện';
      } else if (this.action === this.actionEditor.EDITOR_LAYER) {
        var itemSelected = this.items[this.itemSelected];
        switch (itemSelected.extractData.typeLayer) {
          case this.typeLayer.AREA_TEXT : {
            return 'Cấu hình vùng chữ';
          }
          case this.typeLayer.AREA_LEFT : {
            return 'Cấu hình vùng trái';
          }
          case this.typeLayer.AREA_RIGHT : {
            return 'Cấu hình vùng phải';
          }
          case this.typeLayer.FULL_SCREEN : {
            return `Cấu hình toàn màn hình`;
          }
        }
      }
    },
  },
  created() {
  },
  mounted() {
  },
  methods: {
    getTitleLayer(item) {
      switch (item.extractData.typeLayer) {
        case this.typeLayer.AREA_TEXT : {
          return `Vùng văn bản`;
        }
        case this.typeLayer.AREA_LEFT : {
          return `Vùng trái`;
        }
        case this.typeLayer.AREA_RIGHT : {
          return `Vùng phải`;
        }
        case this.typeLayer.FULL_SCREEN : {
          return `Toàn màn hình`;
        }
      }
    },
    checkMoveLayer(e) {
      this.$emit("change:layer", e);
    },
    activeLayer(id) {
      this.$emit("active:layer", id);
    },
    removeLayer(id) {
      this.$emit("remove:layer", id);
    },
    chooseLayer(element) {
      if (!element.disabled) {
        this.$emit("choose:layer", element);
      }
    },
    validateItems() {
      if (this.items && this.items.length === 0) {
        this.isValidSubmit = true;
      } else {
        this.isValidSubmit = false;
      }
    },
    submitSaveSlideShow() {
      this.validateItems();
      if (this.isValidSubmit) {
        this.showErrorMsg({message: 'Vui lòng kiểm tra tiêu đề và bố cục giao diện'});
        return;
      }
      let that = this;
      this.$emit("loading", true);
      var items = [];
      this.items.map(each => {
        var item = Object.assign({}, each);
        delete item.extractData;
        var _extractData = each.extractData;
        item.active = false;
        item.extractData = {
          // id: _extractData.id ? _extractData.id : null,
          typeLayer: _extractData.typeLayer,
        }
        items.push(item);
      })
      var _urlAPI = '/config_slide_show_central/add';
      var objDataRequest = {
        widthDesign: that.size.width,
        heightDesign: that.size.height,
        ratio: that.ratioSelect.data.model,
        type: this.typeSelect.data.model,
        draggableModels: items
      };
      if (this.$route.params.id) {
        objDataRequest.id = this.$route.params.id;
        _urlAPI = '/config_slide_show_central/update';
      }
      this.$helper.loadDataSource({
        url: _urlAPI,
        dataSubmit: function () {
          return objDataRequest;
        },
        ignoreDefaultData: true,
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.$emit("loading", false);
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
          } else {
            if (that.$route.params.id) {
              that.showSuccessMsg({message: "Cập nhật trình diễn thành công"});
            } else {
              that.showSuccessMsg({message: "Thêm mới trình diễn thành công"});
            }
            that.$router.push("/files-screen-management/slide-show-central.html");
          }
        },
        errorCallback: function (error) {
          that.$emit("loading", true);
          that.$helper.handleError(that.$router, error);
        },
      });
    }
  },
  watch: {
    type(value) {
      this.typeSelect.data.model = value;
    },
    'typeSelect.data.model': function (value) {
      this.$emit("change:type", value);
    },
    items(value) {
      if (this.typeSelect.data.model == 1) {
        this.itemsLayerChoose.map(each => {
          var item = value.find(item => item.extractData.typeLayer == each.typeLayer);
          if (item) {
            each.disabled = true;
          } else {
            each.disabled = false;
          }
        })
      }
    }
  },
  destroyed() {
  }
}
</script>

<style scoped>
video {
  object-fit: contain;
}

.group-layer-setting .title {
  border-radius: unset !important;
  position: unset !important;
  background: white !important;
  border-bottom: unset !important;
  font-size: 16px;
  font-weight: bold;
  width: 100%;
  padding-left: 13px;
}

.group-layer-setting .layers-wrapper ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.group-layer-setting .layers-wrapper ul > li {
  margin-bottom: 4px;
  background: #E8E9EC !important;
  border-radius: 4px;
  color: #4B4B50 !important;
  padding: 10px;
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.group-layer-setting .no-layers-content-message {
  font-style: italic;
  font-size: 12px;
}

.layout-insert-item-column {
  padding: 0;
  padding-right: 12px;
  text-align: center;
}

.layout-insert-item-type {
  border-radius: 3px;
  width: 100%;
  height: 80px;
  background: #dcdcdc;
  color: #fff;
  cursor: pointer;
  transition: all ease-in-out .5s;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

.layout-insert-item-type:hover {
  background: rgba(157, 151, 151, 0.49);
}

.text-right {
  cursor: pointer;
  border: 1px solid #00000040;
  padding: -4px;
  border-radius: 5px;
  width: 23px;
  height: 23px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

.text-right:hover {
  background: rgba(128, 128, 128, 0.3);
  color: white;
}
</style>
<style>
#config-slide-show-editor .group-color-picker {
  position: relative;
}

#config-slide-show-editor .one-colorpicker {
  position: absolute;
  top: 1px;
  right: 1px;
}

#config-slide-show-editor .color-block {
  width: 28px;
  height: 34px;
}

#config-slide-show-editor .color-block-layer.value {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}

#config-slide-show-editor .disabled {
  cursor: no-drop !important;
  /*pointer-events: none;*/
  justify-content: center;
  align-content: center;
}
</style>
